export default __webpack_public_path__ + "static/media/6.9a695e47.png";